import React, { Component } from 'react';
import MiCompAPI from '../../util/api';
import jwtDecode from 'jwt-decode';
import Routes from '../Layout/Routes';
import InviteLaunchPad from '../User/Registration/InviteLaunchPad';
import base64 from 'react-native-base64'
import ConfirmPassForm from './ConfirmPassForm';
import ForgetPassWord from './ForgetPassWord';
import NormalLoginForm from './NormalLoginForm';
import { Form, message, Spin } from 'antd';
import SecurityQuestion from './SecurityQuestion';
import RegistrationLaunchPad from '../User/Registration/RegistrationLaunchPad';
import RegistrationCompletion from '../User/Registration/RegistrationCompletion';
import LaunchPad from '../User/Registration/LaunchPad';
const WrappedNormalLoginForm = Form.create({ name: 'normal_login' })(NormalLoginForm);
const ForgetPasswordForm = Form.create({ name: 'normal_login' })(ForgetPassWord);
const ConfirmPasswordForm = Form.create({ name: 'normal_login' })(ConfirmPassForm);
const SecurityQuestionForm = Form.create({ name: 'normal_login' })(SecurityQuestion);

class Authcontrol extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: false,
      isLoading: true,
      isprofiledone: false,
      userMenusandActions: [],
      masters: null,
      isforgetpass: false,
      decodedToken: [],
      sqs: [],
      issqpage: false,
      isconfirmpassword: false,
      user: []
    }
    this.api = new MiCompAPI(null);
  }
  componentDidMount = () => {
    this.getSessionStatus();
  }
  getSessionStatus = () => {
    this.setState({ isLoading: true })
    let token = sessionStorage.getItem("token");
    this.setState({
      isprofiledone: sessionStorage.getItem("isprofiledone")
    })
    var dateNow = new Date();
    if (token !== null && token !== "") {
      const decodedToken = jwtDecode(token)
      this.setState({
        role: decodedToken.userRoleName
      })
      if (decodedToken.exp > dateNow.getTime()) {
        this.setState({ isLoggedIn: false })
      } else {
        this.getPermissions(decodedToken);
      }
    } else {
      this.setState({ isLoggedIn: false })
    }
    this.setState({ isLoading: false })
  }
  getPermissions = (decodedToken) => {
    this.api.invoke("Menus", "get", (data, success) => {
      if (success) {
        this.setState({ isLoggedIn: true, isLoading: false, userMenusandActions: { ...data.data, decodedToken } });
      }
    })
    
  }
  confirmpassword = (values) => {
    this.setState({ isLoading: true })

    var data = {
      id: values.id,
      value: values.password
    }
    this.api.invoke("ConfirmPassword", "post", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          this.setState({
            isLoading: false,
            isLoggedIn: false,
            isforgetpass:false
          });
          message.destroy();
          message.success(data.statusMessage, 3);
          sessionStorage.clear();
          window.location.pathname = "";
        }
        this.setState({
          isLoading: false,
         
        });
      }
    }, data)
  }
  ForgetPasswordGetSQ = (values) => {
    this.setState({ isLoading: true })
    var data = {
      id: 0,
      value: values.email
    }
    this.api.invoke("ForgetPasswordGetSQ", "post", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          this.setState({ isLoading: false, issqpage: true,isconfirmpassword: false, sqs: data.data })


        }else
        {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
    }, data)
  }
  SecurityQuestionsubmit=(data)=>{
    this.api.invoke("ForgetPassword", "post", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          this.setState({ isLoading: false, isconfirmpassword: true,issqpage:false, user: data.data })


        }else
        {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
    }, data)
  }
  authenticate = (values, callback) => {
    this.setState({ isLoading: true })

    const authData = {
      userName: values.username,
      password: values.password,
      isMember: values.isMember,

    }
    this.api.invoke("Login", "post", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          sessionStorage.setItem("token", data.data.token);
          sessionStorage.setItem("isprofiledone", data.data.isregistered);
          this.setState({ isprofiledone: data.data.isregistered })
          this.getPermissions(jwtDecode(data.data.token));
          callback(true, data.statusMessage);
        }
        else {
          callback(false, data.statusMessage);
        }
      }
      else {
        callback(false, "Failed to Login");

      }
      this.setState({ isLoading: false })

    }, authData);
  }
  forget = () => {
    this.setState({
      isforgetpass: true
    });
  }
  RegistrationDone = () => {

    sessionStorage.setItem("isprofiledone", true);

    this.setState({
      isprofiledone: true
    })
  }
  render() {
    
    if (this.state.isLoading) {
      return (
        <Spin size="large" >
          <div style={{ textAlign: "center", marginTop: "15%" }}>
            <h2>Loading. Please wait...</h2>
          </div>
        </Spin>
      );
    }
    else {
      var inviteInfo = window.location.pathname.split('/');
      if (this.state.isLoggedIn) {

        const { decodedToken } = this.state.userMenusandActions;
        if (this.state.isprofiledone && this.state.isprofiledone !== 'false') {
          return (
            <Routes userPermandMasters={this.state.userMenusandActions} role={this.state.role} />
          );
        } else {
          return (
            <RegistrationCompletion type={decodedToken.UserRoleName} RegistrationDone={this.RegistrationDone} id={decodedToken.UserId} />
          );
        }
      } else if (this.state.isforgetpass) {
        if (!this.state.issqpage && !this.state.isconfirmpassword) {
          return <ForgetPasswordForm handleAuthentication={this.ForgetPasswordGetSQ} />

        }
        if (this.state.issqpage) {
          return <SecurityQuestionForm data={this.state.sqs} handleAuthentication={this.SecurityQuestionsubmit}></SecurityQuestionForm>;
        }
        if (this.state.isconfirmpassword) {
          return <ConfirmPasswordForm id={this.state.user.id} handleAuthentication={this.confirmpassword} />;

        }
      }

      else if (inviteInfo[1] === "invite") {
        
        var url1 = base64.decode(inviteInfo[2]).split("/");
        return <InviteLaunchPad type={url1[0]} id={url1[1]} />;
      } else if (inviteInfo[1] === "register") {
        
        if(inviteInfo[2])
        return <RegistrationLaunchPad type={inviteInfo[2]} />;
        else
        return <LaunchPad  />;

      }
      else if (!this.state.isLoggedIn) {
        return (
          <WrappedNormalLoginForm handleAuthentication={this.authenticate} forget={this.forget} />
        );
      }
    }
  }
}
export default Authcontrol;
